import { useDispatch } from "react-redux";
import { addNode } from "../utils/flowSlice";
import { FaGlobe } from "react-icons/fa";
import { DarkModeContext } from "../context/DarkModeContext";
import { useContext, useState } from "react";

const Website = () => {
  const { darkMode } = useContext(DarkModeContext);
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    dispatch(addNode({ type: "websiteNode" }));
  };

  // State to track hover for each icon
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleMouseEnter = (id) => {
    setActiveTooltip(id);
  };

  const handleMouseLeave = () => {
    setActiveTooltip(null);
  };

  return (
    <div
      className="rounded-lg flex justify-center items-center relative hover:cursor-pointer"
      onMouseEnter={() => handleMouseEnter("website")}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`w-10 h-10 mt-0.5 mx-0.5 flex items-center justify-center rounded-full transition opacity-50 ${
          darkMode ? "text-neutral-600" : "text-white"
        } `}
        onClick={handleButtonClick}
      >
        <FaGlobe size={20} />
      </button>
      {activeTooltip === "website" && (
        <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-700 text-white text-xs rounded py-1 px-2 z-10">
          Website
        </span>
      )}
    </div>
  );
};

export default Website;
